import React, { useContext, useMemo, useState } from "react";
import ContrySelect from '../../../components/contryselect/ContrySelect'
import countryList from "react-select-country-list";
import toast from "react-hot-toast";
import { Grid, TextField, Typography, Button, Checkbox, FormControlLabel } from "@mui/material";
import { DemoLoginApi } from '../../../api/request/auth';
import { ThemeContext } from "../../../context/ThemeContext";
import CompanyDetail from "./CompanyDetail";
import { useTranslation } from "react-i18next";

const OpenDemoAccount = ({ companyData }) => {
  const { darkMode } = useContext(ThemeContext)
  const [formValues, setFormValues] = useState({ address: "", country: "", deposit: "100000", email: "", name: "", phone: "", nodeID: 2, agree: false, });
  const [isCompanyDetailsVisible, setIsCompanyDetailsVisible] = useState(false);
  const countries = useMemo(() => countryList().getData(), []);
  const { t } = useTranslation()
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormValues({ ...formValues, [name]: checked });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents the default form submission behavior

    try {
      let params = {
        login_type: "api",
        ...formValues,
        country: formValues.country,
      };
      const { data } = await DemoLoginApi(params);

      if (data) {
        toast.success("Account Created successfully! Please Login");
      } else {
        toast.error("Account Creation failed");
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("An error occurred while logging in.");
      }
    }
  };

  const handleCountryChange = (selectedOption) => {
    setFormValues({ ...formValues, country: selectedOption?.label || "" });
  };

  const handleCompanyClick = () => {
    setIsCompanyDetailsVisible(!isCompanyDetailsVisible);
  };

  return (
    <form onSubmit={handleSubmit}>
      {isCompanyDetailsVisible ? (
        <CompanyDetail onBackToLogin={handleCompanyClick} />
      ) : (
        <Grid container spacing={2} sx={{ padding: "15px" }}>
          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={12}>
              <Typography variant="body1" gutterBottom sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('openDemoAccount')}</Typography>
            </Grid>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('company')} </Typography></Grid>
            <Grid item xs={8}><Typography variant="body2" sx={{ cursor: 'pointer' }} className="text-primary" onClick={handleCompanyClick}>{companyData.companyName}</Typography></Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('username')}</Typography></Grid>
            <Grid item xs={8}>
              <TextField placeholder={t('username')} name="name" variant="outlined" fullWidth size="small" value={formValues.name} onChange={handleInputChange} className="custom-textfield" />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}> <Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('email')} </Typography></Grid>
            <Grid item xs={8}><TextField name="email" variant="outlined" fullWidth placeholder={t('email')} size="small" value={formValues.email} onChange={handleInputChange} className="custom-textfield" /></Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t("MobilePhone")}</Typography> </Grid>
            <Grid item xs={8}>
              <TextField placeholder={t('PhoneNumber')} name="phone" variant="outlined" fullWidth size="small" value={formValues.phone} onChange={handleInputChange} className="custom-textfield" />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('address')} </Typography> </Grid>
            <Grid item xs={8}>
              <TextField placeholder={t('address')} name="address" variant="outlined" fullWidth size="small" value={formValues.address} onChange={handleInputChange} className="custom-textfield" />
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t("country")}</Typography></Grid>
            <Grid item xs={8}>
              <ContrySelect placeholder={t('selectcountry')} options={countries} value={countries.find(option => option.label === formValues.country)} onChange={handleCountryChange} />
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('deposit')}</Typography></Grid>
            <Grid item xs={8}><TextField sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }} name="deposit" variant="outlined" size="small" fullWidth value={formValues.deposit} onChange={handleInputChange} className="custom-textfield" /></Grid>
          </Grid>


          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
            <Grid item xs={12}>
              <FormControlLabel control={
                <Checkbox name="agree" checked={formValues.agree} onChange={handleCheckboxChange} className="custom-checkbox" />}
                label={t('agreeText')}
                sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", }, color: darkMode ? "var(--lightText)" : 'var(--black)' }} />
              <Typography className="text-primary" variant="body2" ml={3} mt={1}>https://hybridsolutions.com</Typography>

            </Grid>
          </Grid>
          <Grid container sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Grid item>
              <Button type="submit" variant="contained" color="secondary" size="" sx={{ border: '1px solid green', marginTop: "20px", color: "white", padding: '5px', pl: 2, pr: 2, textTransform: "none", }}>{t('openDemoAccount')} </Button>
            </Grid>
          </Grid>

        </Grid>
      )}
    </form>
  );
};

export default OpenDemoAccount;